export default __webpack_public_path__ + "static/media/star-border.d6e548d0.svg";